import { FC } from "react";

export const PageHeading: FC<{
  logo: string;
  page: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}> = ({ logo, page, style, children }) => {
  return (
    <mui-h-stack alignY="center" space="24px" style={style}>
      <mui-h-stack space="12px" alignY="center">
        <img style={{ width: "36px", height: "auto" }} src={logo} alt={page} />
        <mui-heading level="1" size="2">
          {page}
        </mui-heading>
      </mui-h-stack>
      {children}
    </mui-h-stack>
  );
};
